import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { TrendPoint } from '../../data/metrics';
import { formatShortDate } from '../../data/metrics';
import { formatLongDay, formatNumber } from '../../data/overviewStory';

interface Props {
  data: TrendPoint[];
  /** Nom de la métrique au pluriel, ex. « Signatures ». */
  label: string;
}

// Une seule teinte : barres claires pour le quotidien, ligne foncée pour la tendance.
const BAR_COLOR = '#7b93cc';
const AVERAGE_COLOR = '#1e3a8a';

export function DailyTrendChart({ data, label }: Props) {
  const rows = data.map((point) => ({ ...point, dayLabel: formatShortDate(point.day) }));
  return (
    <div className="ci-chart">
      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart data={rows} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid vertical={false} stroke="#eef1f4" />
          <XAxis dataKey="dayLabel" fontSize={11} stroke="#6b7280" tickLine={false} minTickGap={16} />
          <YAxis
            fontSize={11}
            stroke="#6b7280"
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
            width={48}
            tickFormatter={(v: number) => formatNumber(v)}
          />
          <Tooltip
            cursor={{ fill: 'rgba(30, 58, 138, 0.06)' }}
            labelFormatter={(_, payload) => {
              const day = payload?.[0]?.payload?.day as string | undefined;
              return day ? formatLongDay(day) : '';
            }}
            formatter={(value, name) => [formatNumber(Number(value)), String(name)]}
            contentStyle={{ fontSize: 12, border: '1px solid #cbd0d8', borderRadius: 4 }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="value" name={`${label} par jour`} fill={BAR_COLOR} radius={[4, 4, 0, 0]} maxBarSize={28} />
          <Line
            dataKey="average"
            name="Moyenne sur 7 jours"
            type="monotone"
            stroke={AVERAGE_COLOR}
            strokeWidth={2}
            dot={false}
            connectNulls
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
